import { useEffect, useState } from 'react';
import { useCoreAuth } from '@carvana/core-auth';

export const useAuthToken = () => {
  const [userInfo, setUserInfo] = useState({
    authName: undefined,
    hasTokenExpired: true,
    isAuthLoading: true,
    accessToken: undefined
  });
  const { getUserState } = useCoreAuth();
  const { isLoggedIn, isValidToken, user } = getUserState();

  useEffect(() => {
    if (isLoggedIn && isValidToken) {
      try {
        const { user_id, given_name } = user;

        if (user_id)
          setUserInfo(() => ({
            authName: given_name,
            hasTokenExpired: !isValidToken,
            id: user_id,
            accessToken: user.cvAccessToken,
            isAuthLoading: false
          }));
      } catch (error) {
        console.error('failed to get access token', error);
      }
    }

    setUserInfo((data) => ({
      ...data,
      isAuthLoading: false
    }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, isValidToken]);

  return userInfo;
};
